import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * Selection of a value with radiobuttons.
 * @inheritDoc
 */
export class FormModelRadio extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'radio';

  /**
   * @inheritDoc
   * @param id
   * @param options List of options we want to show.
   * @param validators
   * @param unit
   * @param value
   * @param info
   */
  constructor(id: string, options: any[], validators: ValidatorFn[] = [], unit: string = null, value: any = null, info: boolean = true) {
    super(id, validators, unit, value, info);

    this.options = options;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelRadio {
    // @ts-ignore
    return new this.constructor(this.id, this.options, this.validators, this.unit, this.value, this.info);
  }

  /**
   * Sets a path for the icons of this element
   * @param iconPath
   */
  public setIconPath(iconPath: string): FormModelRadio {
    this.fieldData.iconPath = iconPath;
    return this;
  }
}
